import React from 'react'

import { twMerge } from 'tailwind-merge'

type ColumnCount = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

interface GridListProps {
  mobileColumns?: ColumnCount
  tabletColumns?: ColumnCount
  desktopColumns?: ColumnCount
  children: React.ReactNode
  className?: string
}

const columnClassMap: Record<
  ColumnCount,
  { mobile: string; tablet: string; desktop: string }
> = {
  1: {
    mobile: 'grid-cols-1',
    tablet: 'sm:grid-cols-1',
    desktop: 'xl:grid-cols-1',
  },
  2: {
    mobile: 'grid-cols-2',
    tablet: 'sm:grid-cols-2',
    desktop: 'xl:grid-cols-2',
  },
  3: {
    mobile: 'grid-cols-3',
    tablet: 'sm:grid-cols-3',
    desktop: 'xl:grid-cols-3',
  },
  4: {
    mobile: 'grid-cols-4',
    tablet: 'sm:grid-cols-4',
    desktop: 'xl:grid-cols-4',
  },
  5: {
    mobile: 'grid-cols-5',
    tablet: 'sm:grid-cols-5',
    desktop: 'xl:grid-cols-5',
  },
  6: {
    mobile: 'grid-cols-6',
    tablet: 'sm:grid-cols-6',
    desktop: 'xl:grid-cols-6',
  },
  7: {
    mobile: 'grid-cols-7',
    tablet: 'sm:grid-cols-7',
    desktop: 'xl:grid-cols-7',
  },
  8: {
    mobile: 'grid-cols-8',
    tablet: 'sm:grid-cols-8',
    desktop: 'xl:grid-cols-8',
  },
  9: {
    mobile: 'grid-cols-9',
    tablet: 'sm:grid-cols-9',
    desktop: 'xl:grid-cols-9',
  },
  10: {
    mobile: 'grid-cols-10',
    tablet: 'sm:grid-cols-10',
    desktop: 'xl:grid-cols-10',
  },
  11: {
    mobile: 'grid-cols-11',
    tablet: 'sm:grid-cols-11',
    desktop: 'xl:grid-cols-11',
  },
  12: {
    mobile: 'grid-cols-12',
    tablet: 'sm:grid-cols-12',
    desktop: 'xl:grid-cols-12',
  },
}

const GridList: React.FC<GridListProps> = ({
  mobileColumns = 1,
  tabletColumns = 2,
  desktopColumns = 4,
  children,
  className,
}) => {
  const gridClasses = [
    'grid gap-y-7 xl:gap-y-10 gap-x-4',
    columnClassMap[mobileColumns].mobile,
    columnClassMap[tabletColumns].tablet,
    columnClassMap[desktopColumns].desktop,
  ]

  return (
    <div data-testid="grid-list" className={twMerge(...gridClasses, className)}>
      {children}
    </div>
  )
}

export default GridList
